import LineClamp from '@space-core/components/lineClamp'
import { useTranslation } from 'react-i18next'

const DEFAULT_CLAMP = 2

export type LiveDetailsProps = {
  productName: string
  liveName: string
  titleClamp?: number
}

const LiveDetails = ({ productName, liveName, titleClamp = DEFAULT_CLAMP }: LiveDetailsProps) => {
  const { t } = useTranslation()

  return (
    <>
      <LineClamp
        lines={1}
        title={productName}
        id='product-name'
        className='_text-gray-600 _mb-2 _text-1'>
        {productName}
      </LineClamp>
      <LineClamp
        lines={titleClamp}
        title={t('live.card.title', { title: liveName })}
        id='card-title'
        className='_text-2 _font-weight-bold _text-gray-900 _mb-0'>
        {t('live.card.title', { title: liveName })}
      </LineClamp>
    </>
  )
}

export default LiveDetails
